module.exports = {
	"_args": [
		[
			{
				"raw": "mapbox.js@^3.0.1",
				"scope": null,
				"escapedName": "mapbox.js",
				"name": "mapbox.js",
				"rawSpec": "^3.0.1",
				"spec": ">=3.0.1 <4.0.0",
				"type": "range"
			},
			"C:\\Users\\Suheel\\clogin"
		]
	],
	"_from": "mapbox.js@>=3.0.1 <4.0.0",
	"_id": "mapbox.js@3.1.1",
	"_inCache": true,
	"_location": "/mapbox.js",
	"_nodeVersion": "7.7.1",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/mapbox.js-3.1.1.tgz_1495570579259_0.4753663376905024"
	},
	"_npmUser": {
		"name": "tristen",
		"email": "tristen.brown@gmail.com"
	},
	"_npmVersion": "4.1.2",
	"_phantomChildren": {},
	"_requested": {
		"raw": "mapbox.js@^3.0.1",
		"scope": null,
		"escapedName": "mapbox.js",
		"name": "mapbox.js",
		"rawSpec": "^3.0.1",
		"spec": ">=3.0.1 <4.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/mapbox.js/-/mapbox.js-3.1.1.tgz",
	"_shasum": "4ebe41bd89b533f507fb3455f4f490e417ea1e8f",
	"_shrinkwrap": null,
	"_spec": "mapbox.js@^3.0.1",
	"_where": "C:\\Users\\Suheel\\clogin",
	"author": {
		"name": "Mapbox"
	},
	"bugs": {
		"url": "https://github.com/mapbox/mapbox.js/issues"
	},
	"config": {
		"commitizen": {
			"path": "./node_modules/cz-conventional-changelog"
		}
	},
	"dependencies": {
		"corslite": "0.0.6",
		"isarray": "0.0.1",
		"leaflet": "1.0.2",
		"mustache": "2.2.1",
		"sanitize-caja": "0.1.4"
	},
	"description": "mapbox javascript api",
	"devDependencies": {
		"browserify": "^13.0.0",
		"clean-css": "~2.0.7",
		"cz-conventional-changelog": "1.2.0",
		"eslint": "^0.23.0",
		"expect.js": "0.3.1",
		"happen": "0.1.3",
		"leaflet-fullscreen": "0.0.4",
		"leaflet-hash": "0.2.1",
		"marked": "~0.3.0",
		"minifyify": "^6.1.0",
		"minimist": "0.0.5",
		"mocha": "2.4.5",
		"mocha-phantomjs-core": "2.0.1",
		"phantomjs-prebuilt": "2.1.12",
		"sinon": "1.10.2"
	},
	"directories": {},
	"dist": {
		"shasum": "4ebe41bd89b533f507fb3455f4f490e417ea1e8f",
		"tarball": "https://registry.npmjs.org/mapbox.js/-/mapbox.js-3.1.1.tgz"
	},
	"engines": {
		"node": "*"
	},
	"gitHead": "8a52b388a21e7de418c2a61448bf33107c5db766",
	"homepage": "http://mapbox.com/",
	"license": "BSD-3-Clause",
	"main": "src/index.js",
	"maintainers": [
		{
			"name": "mollymerp",
			"email": "mollylloyd@gmail.com"
		},
		{
			"name": "arunasank",
			"email": "aruna@mapbox.com"
		},
		{
			"name": "amyleew",
			"email": "amyleewalton@gmail.com"
		},
		{
			"name": "mapbox-admin",
			"email": "accounts@mapbox.com"
		},
		{
			"name": "mtirwin",
			"email": "irwin@mapbox.com"
		},
		{
			"name": "1ec5",
			"email": "mxn@1ec5.org"
		},
		{
			"name": "apendleton",
			"email": "andrew@mapbox.com"
		},
		{
			"name": "alulsh",
			"email": "ulsh@mapbox.com"
		},
		{
			"name": "karenzshea",
			"email": "karen@mapbox.com"
		},
		{
			"name": "freenerd",
			"email": "spam@freenerd.de"
		},
		{
			"name": "flippmoke",
			"email": "flippmoke@gmail.com"
		},
		{
			"name": "bergwerkgis",
			"email": "wb@bergwerk-gis.at"
		},
		{
			"name": "themarex",
			"email": "patrick@mapbox.com"
		},
		{
			"name": "emilymcafee",
			"email": "emily@mapbox.com"
		},
		{
			"name": "jrpruit1",
			"email": "jake@jakepruitt.com"
		},
		{
			"name": "sbma44",
			"email": "tlee@mapbox.com"
		},
		{
			"name": "scothis",
			"email": "scothis@gmail.com"
		},
		{
			"name": "lyzidiamond",
			"email": "lyzi@mapbox.com"
		},
		{
			"name": "bhousel",
			"email": "bryan@mapbox.com"
		},
		{
			"name": "mcwhittemore",
			"email": "mcwhittemore@gmail.com"
		},
		{
			"name": "tristen",
			"email": "tristen.brown@gmail.com"
		},
		{
			"name": "ansis",
			"email": "ansis.brammanis@gmail.com"
		},
		{
			"name": "yhahn",
			"email": "young@mapbox.com"
		},
		{
			"name": "willwhite",
			"email": "will@mapbox.com"
		},
		{
			"name": "jfirebaugh",
			"email": "john.firebaugh@gmail.com"
		},
		{
			"name": "mourner",
			"email": "agafonkin@gmail.com"
		},
		{
			"name": "sgillies",
			"email": "sean@mapbox.com"
		},
		{
			"name": "lbud",
			"email": "lauren@mapbox.com"
		},
		{
			"name": "bsudekum",
			"email": "bobby@mapbox.com"
		},
		{
			"name": "dnomadb",
			"email": "damon@mapbox.com"
		},
		{
			"name": "ian29",
			"email": "ian.villeda@gmail.com"
		},
		{
			"name": "nickidlugash",
			"email": "nicki@mapbox.com"
		},
		{
			"name": "samanbb",
			"email": "saman@mapbox.com"
		},
		{
			"name": "ajashton",
			"email": "aj@mapbox.com"
		},
		{
			"name": "lxbarth",
			"email": "alex@mapbox.com"
		},
		{
			"name": "ianshward",
			"email": "ian@mapbox.com"
		},
		{
			"name": "ingalls",
			"email": "nicholas.ingalls@gmail.com"
		},
		{
			"name": "miccolis",
			"email": "jeff@miccolis.net"
		},
		{
			"name": "gretacb",
			"email": "carol@mapbox.com"
		},
		{
			"name": "morganherlocker",
			"email": "morgan.herlocker@gmail.com"
		},
		{
			"name": "rclark",
			"email": "ryan.clark.j@gmail.com"
		},
		{
			"name": "springmeyer",
			"email": "dane@mapbox.com"
		},
		{
			"name": "kkaefer",
			"email": "mail@kkaefer.com"
		}
	],
	"name": "mapbox.js",
	"optionalDependencies": {},
	"readme": "# mapbox.js\n\n[![Build Status](https://travis-ci.org/mapbox/mapbox.js.svg?branch=v1)](https://travis-ci.org/mapbox/mapbox.js) [![Average time to resolve an issue](http://isitmaintained.com/badge/resolution/mapbox/mapbox.js.svg)](http://isitmaintained.com/project/mapbox/mapbox.js \"Average time to resolve an issue\")\n\nThis is the Mapbox Javascript API, version 2.x. It's built as a [Leaflet](http://leafletjs.com/)\nplugin. You can [read about its launch](http://mapbox.com/blog/mapbox-js-with-leaflet/).\n\n## [API](http://mapbox.com/mapbox.js/api/)\n\nManaged as Markdown in `API.md`, following the standards in `DOCUMENTING.md`\n\n## [Examples](http://mapbox.com/mapbox.js/example/v1.0.0/)\n\n## Usage\n\nRecommended usage is via the Mapbox CDN, with [code snippets available on the official documentation page](https://www.mapbox.com/mapbox.js/)\n\nThe `mapbox.js` file includes the Leaflet library. Alternatively, you can use `mapbox.standalone.js`, which does not include Leaflet (you will have to provide it yourself).\n\nSee the [API documentation](http://mapbox.com/mapbox.js/api/) and [Examples](http://mapbox.com/mapbox.js/example/v1.0.0/) for further help.\n\n## Usage with [Browserify](http://browserify.org/)\n\nInstall the mapbox.js module and add it to `dependencies` in package.json:\n\n```sh\nnpm install mapbox.js --save\n```\n\nRequire mapbox in your script:\n\n```js\n// main.js\n\nrequire('mapbox.js'); // <-- auto-attaches to window.L\n```\n\nBrowserify it:\n\n```sh\nbrowserify main.js -o bundle.js\n```\n\n## Usage with Bower\n\nYou can install `mapbox.js` with [bower](http://bower.io/) by running\n\n```sh\nbower install mapbox.js\n```\n\n## Usage as Download\n\nYou can [download a built release at the mapbox.js-bower repository](https://github.com/mapbox/mapbox.js-bower/releases).\n\n## Building\n\nRequires [node.js](http://nodejs.org/) installed on your system.\n\n``` sh\ngit clone https://github.com/mapbox/mapbox.js.git\ncd mapbox.js\nnpm install\nmake\n```\n\nThis project uses [browserify](https://github.com/substack/node-browserify) to combine\ndependencies and installs a local copy when you run `npm install`.\n`make` will build the project in `dist/`.\n\n### Tests\n\nTest with [phantomjs](http://phantomjs.org/):\n\n``` sh\nnpm test\n```\n\nTo test in a browser, run a [local development server](https://gist.github.com/tmcw/4989751)\nand go to `/test`.\n\n### Version v0.x.x\n\n[Version v0.x.x can be accessed in the v0 branch.](https://github.com/mapbox/mapbox.js/tree/v0).\n\n### Editing Icons\n\nRequirements:\n\n    inkscape\n    pngquant\n\n1. Make edits to `theme/images/icons.svg`.\n2. Run `./theme/images/render.sh` to update sprites from your edits.\n3. Add a CSS reference with the appropriate pixel coordinate if adding a new icon.\n\n### Running docuemntation locally\n\nDocumentation is powered by [Jekyll](http://jekyllrb.com/). Running using the\nfollowing command:\n\n\n``` sh\n./jekyll.sh\n```\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "git://github.com/mapbox/mapbox.js.git"
	},
	"scripts": {
		"test": "eslint --no-eslintrc -c .eslintrc src && phantomjs node_modules/mocha-phantomjs-core/mocha-phantomjs-core.js test/index.html"
	},
	"version": "3.1.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/package.json
// module id = 197
// module chunks = 0